export default "__VITE_PUBLIC_ASSET__71877b9b__"